<template>
	<div
		:class="[
			'alert-box__box',
			{ 'alert-box__box-warning': item.type === 'warning' },
			{ 'alert-box__box-error': item.type === 'error' }
		]"
	>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 20"
			class="alert-box__success"
		>
			<path
				:class="[
					{ active: success },
					{ warning: item.type === 'warning' },
					{ error: item.type === 'error' }
				]"
				d="M3 8, L8 13, L18 3"
			/>
		</svg>
		<p>{{ item.labels.text }}</p>
	</div>
</template>
<script>
export default {
	props: {
		item: {
			type: Object,
			required: true
		}
	},
	data: () => ({
		success: false
	}),
	mounted() {
		this.success = true
		setTimeout(() => {
			this.removeAlert()
		}, 2000)
		if (this.item.redirect) {
			this.$router.push(this.item.redirect)
		}
	},
	methods: {
		removeAlert() {
			this.$store.dispatch('alert/removeBox', this.item.id)
		}
	}
}
</script>
